module.exports = __webpack_public_path__ + "img/help_02.a2aedeea.png";